import { Message } from 'element-ui';
import router from './router'
const fileType={
    img:'.jpg,.jpeg,.png',
    video:'.mp4',
    pdf:'.pdf',
    exl:'.xlsx,.xls'
  }
export default {
  //日期转字符串格式
  DateToYMD(str) {
    if(!str){
      return "-"
    }
    var date = new Date(str);
    var year = date.getFullYear();//年
    var month = date.getMonth();//月
    var day = date.getDate();//日
    return year + "-" + ((month + 1) > 9 ? (month + 1) : "0" + (month + 1)) + "-" +(day > 9 ? day : ("0" + day))
  },
  DateToY(str) {
    if(!str){
      return "-"
    }
    var date = new Date(str);
    var year = date.getFullYear();//年
    return year
  },
 
  //日期转字符串格式
  DateToYMDHMS(str) {
    if(!str){
      return "-"
    }
    var date = new Date(str);
    var year = date.getFullYear();//年
    var month = date.getMonth();//月
    var day = date.getDate();//日
    var hours = date.getHours();//时
    var min = date.getMinutes();//分
    var second = date.getSeconds();//秒
    return year + "-" + ((month + 1) > 9 ? (month + 1) : "0" + (month + 1)) + "-" +
      (day > 9 ? day : ("0" + day)) + " " + (hours > 9 ? hours : ("0" + hours)) + ":" +
      (min > 9 ? min : ("0" + min)) + ":" + (second > 9 ? second : ("0" + second));
  },
  //日期转字符串格式
  DateNotSpaceToYMDHMS(str) {
    if(!str){
      return "-"
    }
    var date = new Date(str);
    var year = date.getFullYear();//年
    var month = date.getMonth();//月
    var day = date.getDate();//日
    var hours = date.getHours();//时
    var min = date.getMinutes();//分
    var second = date.getSeconds();//秒
    return year +''+ ((month + 1) > 9 ? (month + 1) : "0" + (month + 1)) +''+
      (day > 9 ? day : ("0" + day)) +''+ (hours > 9 ? hours : ("0" + hours)) +''+
      (min > 9 ? min : ("0" + min)) +''+ (second > 9 ? second : ("0" + second));
  },
  //上传验证EXL文件
  validUploadFileExl(file){
    var fileName = file.name;
    var index1=fileName.lastIndexOf(".");
    var index2=fileName.length;
    var type=fileName.substring(index1,index2);
    if (fileType.exl.indexOf(type)==-1) {
      Message.error('只支持'+fileType.exl+'类型文件上传');
      return false;
    }
  },
  //上传验证图片
  validUploadFileImg(file){
    var fileName = file.name;
    var index1=fileName.lastIndexOf(".");
    var index2=fileName.length;
    var type=fileName.substring(index1,index2);
    if (fileType.img.indexOf(type)==-1) {
      Message.error('只支持'+fileType.img+'类型文件上传');
      return false;
    }
  },
  //上传验证视频
  validUploadFileVideo(file){
    var fileName = file.name;
    var index1=fileName.lastIndexOf(".");
    var index2=fileName.length;
    var type=fileName.substring(index1,index2);
    if (fileType.video.indexOf(type)==-1) {
      Message.error('只支持'+fileType.video+'类型文件上传');
      return false;
    }
  },
  //上传验证PDF
  validUploadFilePdf(file){
    var fileName = file.name;
    var index1=fileName.lastIndexOf(".");
    var index2=fileName.length;
    var type=fileName.substring(index1,index2);
    if (fileType.pdf.indexOf(type)==-1) {
      Message.error('只支持'+fileType.pdf+'类型文件上传');
      return false;
    }
  },
  //字典转义
  getNameByValue(list,value){
    for(var i=0;i<list.length;i++){
        if(list[i].value == value){
            return list[i].label;
        }
    }
    return "-";
  },
  dealFileSuccess(res){
    if(res.code==400){
      let msg = res.msg
      Message.error(msg);
      return null
    }else{
      return res.data.url
    }
  },
  //跳转页面并使用params传参 接收参数使用 this.$route.params 
  //页面跳转
  /**
   * 
   * @param {*} url 目标路由的name 比如home
   * @param {*} data 传递的参数，一般是对象 {name:'zhangsan'}
   */
  pushUrl(url,data){
    if(data === undefined || data === null){
      data = {}
    }
    router.push({
      name: url,
      params: data,
    });
  },
  /**
   * 服务器文件url处理 对所有接口返回参数进行递归 把对象中带有服务器ip的文件路径的值处理成file/再由nginx转发
   * 例如： http://118.31.167.85:10033/file/manageImg/20230206180907435/weixinor.png 处理成 file/manageImg/20230206180907435/weixinor.png
   * @param {*} res 
   */
  filePathExec(resData){
    if (Object.prototype.toString.call(resData) === "[object Array]") {
       for(let data in resData){
          this.filePathExec(resData[parseInt(data)]);
       }
    }else if(Object.prototype.toString.call(resData)==='[object Object]'){
      const baseUrl = 'http://118.31.167.85:10033/file/';
      const baseUrl2 = 'http://www.fjcsyit.com:10033/file/';
      for(let colObj in resData){
        let colVal = resData[colObj];
        if(Object.prototype.toString.call(colVal)=="[object String]"){
          if(colVal != undefined && colVal.indexOf(baseUrl)>-1){
            resData[colObj] = colVal.replaceAll(baseUrl,'file/');
          } if(colVal != undefined && colVal.indexOf(baseUrl2)>-1){
            resData[colObj] = colVal.replaceAll(baseUrl2,'file/');
          }
        }else if (Object.prototype.toString.call(colVal) === "[object Array]") {
            for(let data in colVal){
              this.filePathExec(colVal[parseInt(data)]);
            }
        }else if (Object.prototype.toString.call(colVal) === "[object Object]") {
            this.filePathExec(colVal);
        }
      }
    }else{
    }
    return resData;
  },
  //session存储
  setStorage(key,obj){
    sessionStorage.setItem(key,JSON.stringify(obj));
  },
  getStorage(key){
    let obj = sessionStorage.getItem(key);
    return JSON.parse(obj);
  }
}